import React, { Component, Fragment } from 'react';
import Navigation from '../components/Navigation';
import { translate } from 'react-i18next';
import CreateTextLibraryTextRuleForm from '../components/CreateTextLibraryTextRuleForm';
import axios from 'axios';
import { Panel, Col, Row, Button, FormControl, Form } from 'react-bootstrap';
import PlainPanel from '../components/PlainPanel';
import config from '../config';
import { Link } from 'react-router-dom';
import qs from 'qs';

import './CreateTextLibraryTextRule.css';

class CreateTextLibraryTextRule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ruleTypes: [],
            attributes: [],
            rulegroup: { uuid: '' },
            text: { name: '', uuid: '' }
        };
    }

    componentDidMount() {
        this.loadTextsFromServer();
        this.loadRuleGroupFromServer();
        this.loadOrganisationAttributesFromServer();
    }

    loadTextsFromServer() {
        const { textUUID } = this.props.match.params;

        let self = this;
        axios
            .get(`${config.baseURL}/textlibrarytext/${textUUID}`, {})
            .then(function(response) {
                self.setState({ text: response.data.text });
                self.loadTextLibraryFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadTextLibraryFromServer() {
        const {
            uuid,
            textLibraryUUID,
            snippetUUID,
            playerUUID,
            pageUUID
        } = this.props.match.params;

        let self = this;
        axios
            .get(`${config.baseURL}/textlibraries/${textLibraryUUID}`, {})
            .then(function(response) {
                self.setState({ textlibrary: response.data.textlibrary });
                self.loadOrganisationInformation();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadOrganisationInformation() {
        var self = this;

        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}`, {})
            .then(function(response) {
                self.setState({
                    organisation_name: response.data.organisation.name
                });

                const parsed = qs.parse(
                    self.props.location.search.substring(1)
                );
                const rel = parsed.rel;
                if (rel === 'player') {
                    self.loadPlayerFromServer();
                }
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadPlayerFromServer() {
        var self = this;
        const { playerUUID } = this.props.match.params;

        axios
            .get(`${config.baseURL}/players/${playerUUID}`, {})
            .then(function(response) {
                self.setState({
                    player_name: response.data.player.name
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadRuleGroupFromServer() {
        const { textUUID } = this.props.match.params;
        const { ruleGroupUUID } = this.props.match.params;

        let self = this;
        axios
            .get(`${config.baseURL}/textlibrarytext/${textUUID}/rulegroups`, {})
            .then(function(response) {
                if (
                    response.data.rulegroups &&
                    response.data.rulegroups.length > 0
                ) {

                    const rulegroups = response.data.rulegroups;

                    const result = rulegroups.filter(rulegroup => rulegroup.uuid === ruleGroupUUID);

                    self.setState(
                        { rulegroup: result[0] },
                        () => {
                            self.loadRuleTypesFromServer();
                        }
                    );
                }
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadOrganisationAttributesFromServer() {
        const {
            uuid,
            textLibraryUUID,
            playerUUID,
            pageUUID,
            snippetUUID,
            textUUID
        } = this.props.match.params;

        var self = this;
        axios
            .get(`${config.baseURL}/organisations/${uuid}/attributes`, {
                params: {
                    all: true
                }
            })
            .then(function(response) {
                self.setState({
                    attributes: response.data.attributes
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadRuleTypesFromServer() {
        var self = this;
        axios
            .get(`${config.baseURL}/ruletypes`, {
                params: {
                    all: true
                }
            })
            .then(function(response) {
                self.setState({
                    ruleTypes: response.data.ruleTypes
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'CreateTextLibraryTextRule.title'
        )}`;

        const {
            uuid,
            textLibraryUUID,
            playerUUID,
            pageUUID,
            snippetUUID,
            textUUID
        } = this.props.match.params;

        const parsed = qs.parse(this.props.location.search.substring(1));
        const rel = parsed.rel;

        return (
            <div className="CreateTextLibraryTextRule">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <div className="row">
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('CreateTextLibraryTextRule.title')}
                                    {' - '}
                                    {this.state.text.name}{' '}
                                    {rel === 'player' ? (
                                        <small>
                                            {this.state.player_name}{' '}
                                            <small
                                                style={{
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {this.state.organisation_name}
                                            </small>
                                        </small>
                                    ) : (
                                        <small>
                                            {this.state.organisation_name}
                                        </small>
                                    )}
                                </h1>
                                <ol className="breadcrumb">
                                    {rel === 'player' ? (
                                        <Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-tv" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players`}
                                                >
                                                    {t(
                                                        'SideNavigation.players'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-tv" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}`}
                                                >
                                                    {t(
                                                        'OrganisationPlayer.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-file" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/`}
                                                >
                                                    {t('SideNavigation.pages')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-puzzle-piece" />
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}?rel=player`}
                                                >
                                                    {' '}
                                                    {t('Page.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-font" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/textlibrarysnippets/${snippetUUID}?rel=player`}
                                                >
                                                    {t('TextLibrarySnippet.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-font" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/textlibrarysnippets/${snippetUUID}/textlibraries/${textLibraryUUID}?rel=player`}
                                                >
                                                    {t(
                                                        'TextLibrarySnippetTextLibrary.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-clipboard-list" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/textlibrarysnippets/${snippetUUID}/textlibraries/${textLibraryUUID}/texts/${textUUID}/rules?rel=player`}
                                                >
                                                    {t('TextRules.title')}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fa fa-plus" />{' '}
                                                {t('CreateTextLibraryTextRule.title')}
                                            </li>{' '}
                                        </Fragment>
                                    ) : null}
                                    {rel === 'library' ? (
                                        <Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-font" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/textlibraries?rel=library`}
                                                >
                                                    {t(
                                                        'SideNavigation.globaltextlibraries'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-font" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/textlibraries/${textLibraryUUID}?rel=library`}
                                                >
                                                    {t(
                                                        'TextLibrarySnippetTextLibrary.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-clipboard-list" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/textlibraries/${textLibraryUUID}/texts/${textUUID}/rules?rel=library`}
                                                >
                                                    {t('TextRules.title')}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fa fa-plus" />{' '}
                                                {t('CreateTextLibraryTextRule.title')}
                                            </li>{' '}
                                        </Fragment>
                                    ) : null}

                                    {rel === 'snippet' ? (
                                        <React.Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-puzzle-piece" />
                                                <Link
                                                    to={`/organisations/${uuid}/snippets`}
                                                >
                                                    {' '}
                                                    {t(
                                                        'SideNavigation.globalsnippets'
                                                    )}
                                                </Link>
                                            </li>{' '}
                                            <li>
                                                <i className="fas fa-font" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/textlibrarysnippets/${snippetUUID}?rel=snippet`}
                                                >
                                                    {t('TextLibrarySnippet.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-font" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/textlibrarysnippets/${snippetUUID}/textlibraries/${textLibraryUUID}?rel=snippet`}
                                                >
                                                    {t(
                                                        'TextLibrarySnippetTextLibrary.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-clipboard-list" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/textlibrarysnippets/${snippetUUID}/textlibraries/${textLibraryUUID}/texts/${textUUID}/rules?rel=snippet`}
                                                >
                                                    {t('TextRules.title')}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fa fa-plus" />{' '}
                                                {t('CreateTextLibraryTextRule.title')}
                                            </li>{' '}
                                        </React.Fragment>
                                    ) : null}

                                    {rel === 'page' ? (
                                        <React.Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-file" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages`}
                                                >
                                                    {t(
                                                        'SideNavigation.globalpages'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-puzzle-piece" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages/${pageUUID}?rel=page`}
                                                >
                                                    {t('Page.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-font" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages/${pageUUID}/textlibrarysnippets/${snippetUUID}?rel=page`}
                                                >
                                                    {t('TextLibrarySnippet.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-font" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages/${pageUUID}/textlibrarysnippets/${snippetUUID}/textlibraries/${textLibraryUUID}?rel=page`}
                                                >
                                                    {t(
                                                        'TextLibrarySnippetTextLibrary.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-clipboard-list" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages/${pageUUID}/textlibrarysnippets/${snippetUUID}/textlibraries/${textLibraryUUID}/texts/${textUUID}/rules?rel=page`}
                                                >
                                                    {t('TextRules.title')}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fa fa-plus" />{' '}
                                                {t('CreateTextLibraryTextRule.title')}
                                            </li>{' '}
                                        </React.Fragment>
                                    ) : null}
                                </ol>

                                <PlainPanel>
                                    <CreateTextLibraryTextRuleForm
                                        uuid={uuid}
                                        ruleTypes={this.state.ruleTypes}
                                        attributes={this.state.attributes}
                                        ruleGroupUUID={
                                            this.state.rulegroup.uuid
                                        }
                                        textUUID={textUUID}
                                    />
                                </PlainPanel>
                            </Col>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(CreateTextLibraryTextRule);
